import React from 'react';
import { PrimaryButton, OutlineButton } from './Buttons';
import { X } from 'lucide-react';

function ConfirmationModal({
    isOpen,
    onConfirm,
    onCancel,
    message,
    title = 'Confirmation',
    children,
    confirmButtonText = 'Confirm',
    cancelButtonText,
    panelClassName = 'max-w-md',
    isLoading = false,
    loadingText = 'Loading...',
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
            <div className={`bg-white rounded-lg shadow-xl p-6 w-full mx-4 relative ${panelClassName}`}>
                <button
                    onClick={onCancel}
                    disabled={isLoading}
                    className="absolute top-4 right-4 inline-flex items-center justify-center p-2 text-gray-400 hover:text-gray-600 transition-colors duration-200 border border-gray-300 rounded-md hover:border-gray-400"
                >
                    <X size={17.5} />
                </button>
                
                <h3 className="text-lg font-medium text-gray-900 mb-2 pr-8">
                    {title}
                </h3>
                <div className="p-4">
                    {children ? (
                        <div className="text-sm text-gray-700">{children}</div>
                    ) : (
                        <p className="text-md font-normal text-gray-700">
                            {message}
                        </p>
                    )}
                </div>

                <div className="mt-4 flex justify-end space-x-3">
                    {cancelButtonText ? (
                        <OutlineButton onClick={onCancel} disabled={isLoading}>
                            {cancelButtonText}
                        </OutlineButton>
                    ) : null}
                    <PrimaryButton
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="flex items-center">
                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                {loadingText}
                            </div>
                        ) : (
                            confirmButtonText
                        )}
                    </PrimaryButton>
                </div>
            </div>
        </div>
    );
}

export default ConfirmationModal;